var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomHeadline',{attrs:{"custom-title":"GYIK"}}),_vm._l((_vm.faqTitles),function(title,index){return _c('div',{key:index},[_c('FaqAccordion',{attrs:{"title-number":index+1,"title-text":title,"items":_vm.myItems}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }